export default "__VITE_ASSET__CsuuEcJO__"